import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const wrapper = css`
  counter-reset: idx;
`;

export const limitMessage = css`
  margin: 10px 0 0;
`;

export const itemWrapper = css`
  display: flex;
  flex-direction: row;
`;

export const itemContainer = css`
  display: flex;
  margin-bottom: 8px;
`;

export const recurrenceContainer = css`
  display: flex;
  flex-direction: column;

  > #value {
    margin: 0 0 10px 26px;
  }

  > #name {
    margin-bottom: 10px;
  }

  > span {
    display: flex;
  }
`;

export const helperBlock = css`
  height: 19px;
  margin-top: 5px;

  > #value {
    margin-left: 26px;
  }
`;

export const counterIndex = css`
  display: flex;

  :before {
    counter-increment: idx;
    content: counter(idx);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    margin-right: 10px;
    min-width: 16px;
  }
`;

export const recurrence = css`
  width: 220px;
  margin-right: 10px;
`;

export const recurrenceName = css`
  width: 300px;
  margin-right: 10px;
`;

export const deleteButton = (isDisabled?: boolean) => css`
  cursor: pointer;
  margin: auto 0;
  color: ${colors.gray.default};

  :hover {
    color: ${colors.gray.dark};
  }

  && {
    font-size: ${fonts.size.larger};
  }

  ${
    isDisabled &&
    css`
    cursor: not-allowed;
    color: ${colors.gray.light};

    :hover {
      color: ${colors.gray.light};
    }
  `
  }
`;
